<template>
<div>
    <v-card flat>
        <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
                <center>
                    <h2>{{ formTitle }}</h2>
                </center>
                <alert-message :message="msg" :messageType="msgType" />
                <v-card ref="form" flat>
                    <v-card-text>
                        <h3>Service details</h3>
                        <v-card-text>
                            <v-text-field v-model="service.name" :rules="nameRules" label="Service name *" style="font-size: 10" clearable required></v-text-field>
                            <v-textarea v-model="service.description" label="Description" clearable></v-textarea>
                        </v-card-text>
                        <alert-message :message="msg" :messageType="msgType" />
                        <form-buttons :valid="valid" @cancel="goBack()" @submit="validate()"></form-buttons>
                    </v-card-text>
                </v-card>
            </v-form>
        </v-card-text>
    </v-card>
</div>
</template>

<script>
import appConstants from "@/utils/appConstants.js";
import FormButtons from "@/components/FormButtons.vue";
import AlertMessage from "@/components/AlertMessage.vue";

export default {
    components: {
        FormButtons,
        AlertMessage,
    },
    data: () => ({
        valid: true,
        nameRules: [(v) => !!v || "Name is required"],
        service: {},
        id: 0,
        formTitle: "",
    }),
    mounted() {
        this.initialize();
    },
    methods: {
        async initialize() {
            this.id = this.$route.params.id;
            this.service = {
                name: appConstants.INITIAL_VALUE,
                description: appConstants.INITIAL_VALUE,
                orgId: appConstants.INITIAL_VALUE,
            };
            if (this.id != 0) {
                this.formTitle = "Edit service";
                try {
                    this.service = await this.getItem(
                        appConstants.SERVICES_API + "/" + this.id
                    );
                } catch (error) {
                    this.handleError(error);
                    this.msg = error.response.data.details;
                }
            } else {
                this.formTitle = "Add new service";
            }
        },
        async validate() {
            if (this.$refs.form.validate()) {
                try {
                    if (this.id == 0) {
                        this.service = await this.postItem(
                            appConstants.SERVICES_API,
                            this.service
                        );
                    } else {
                        this.service = await this.putItem(
                            appConstants.SERVICES_API + "/" + this.id,
                            this.service
                        );
                    }
                    this.$router.push("/services");
                } catch (error) {
                    this.handleError(error);
                    this.msg = error.response.data.details;
                }
            }
        },
    },
};
</script>
